import { api } from './api';
import { setSessionToken, setSessionEmail, setSessionProfile } from '../utils/session';

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({
        url: 'session',
        method: 'POST',
        body,
      }),
      // Persist the session token as a side effect of the mutation so it
      // never has to live in app state
      async onQueryStarted(_arg, { queryFulfilled }) {
        let data;
        try {
          ({ data } = await queryFulfilled);
        } catch {
          // Rejection is surfaced through the mutation's error state
          return;
        }
        try {
          await setSessionToken(data.session_token);
          if (data.email) await setSessionEmail(data.email);
          await setSessionProfile({ location: data.location, permissions: data.permissions });
        } catch (error) {
          // Login succeeded but nothing was stored - every request would
          // 401, so make the failure loud rather than silent
          console.error('Failed to persist session token:', error);
        }
      },
    }),
  }),
});

export const { useLoginMutation } = authApi;
